import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useOne, BaseRecord } from "@refinedev/core";

//Material Design UI + dependencies
import { Box, CircularProgress } from "@mui/material";

//Local Components
import { Breadcrumbs } from "components/breadcrumbs/index";
import { IBreadcrumb } from "interfaces/index";
import { ServiceRequestCreateUpdate } from "components";
import { decryptData } from "utils/crypto";
import { canEditServiceRequestAtStep } from "utils/recordStatuses";

import { LoggedInUserContext } from "contexts/loggedInUserContext";

export const ServiceRequestEditPage: React.FC = () => {
  const params = useParams();
  const serviceRequestId: number = Number(decryptData(decodeURIComponent(params.id ?? "")));

  const [id, setId] = useState(serviceRequestId);
  const { data, isLoading, isError } = useOne({
    resource: "servicerequests",
    id,
  });

  const serviceRequestData: BaseRecord = data?.data ?? [];
  const [breadCrumbsTitle, setBreadCrumbsTitle] = useState<string>("");
  const [breads, setBreads] = useState<IBreadcrumb[]>([]);
  const navigate = useNavigate();
  const { userPermissions } = useContext(LoggedInUserContext);

  useEffect(() => {
    if (serviceRequestData != null && isLoading === false) {
      setBreadCrumbsTitle("Service Request");
      setBreads([
        { label: "Service Requests", path: "/servicerequests" },
        { label: `${serviceRequestData?.title} (SR-${id})`, path: "" },
      ]);
    }
  }, [serviceRequestData]);

  if (canEditServiceRequestAtStep(serviceRequestData?.approvalWorkflowState?.currentStatus, userPermissions) === false) {
    navigate("/error");
  }

  if (isLoading) {
    return (
      <>
        <Breadcrumbs breadcrumbsTitle={breadCrumbsTitle} breadcrumbs={breads} />
        <main id="content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
          <div className="flex-row-fluid" id="content">
            <Box sx={{ display: "flex" }}>
              <CircularProgress color="primary" />
            </Box>
          </div>
        </main>
      </>
    );
  }

  if (isError) {
    return <div>Error: Could not load Service Request data.</div>;
  }

  return (
    <>
      <Breadcrumbs breadcrumbsTitle={breadCrumbsTitle} breadcrumbs={breads} />
      <main id="content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
        <div className="flex-row-fluid" id="content">
          <ServiceRequestCreateUpdate serviceRequestId={serviceRequestId} serviceRequestData={serviceRequestData} />
        </div>
      </main>
    </>
  );
};
